import { Component, Input, OnInit, signal } from '@angular/core';
import { Product } from 'src/app/models/core/product.model';
import { FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductApiService } from 'src/app/services/product/product-api.service';
import { ShareCodeModalComponent } from '../share-code-modal/share-code-modal.component';

@Component({
  selector: 'app-generate-code-modal',
  templateUrl: './generate-code-modal.component.html',
  styleUrls: ['./generate-code-modal.component.scss'],
  standalone: false
})
export class GenerateCodeModalComponent implements OnInit {
  @Input() product!: Product;
  reasonControl = new FormControl('');
  quantity = signal(1);
  limitQuantity = signal(0);
  isMembership = false;
  securityPhrase = signal<string | null>(null);
  shareCode = signal<string | null>(null);
  isLoading = signal(false);

  constructor(
    private modalCtrl: ModalController,
    private toast: CustomToastService,
    private translate: TranslateService,
    private productApi: ProductApiService,
  ) { }

  ngOnInit(): void {
    this.isMembership = this.product.event.membership ? true : false;
    const limit = this.isMembership ? 1 : this.product.limit_quote
    this.limitQuantity.set(limit);
  }

  shouldShowReference(): boolean {
    const ref = this.product?.reference || '';
    return ref.toUpperCase() !== 'SIN REFERENCIA';
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async generateCode() {
    this.isLoading.set(true);

    const quota = this.quantity();
    try {
      const response = await this.productApi
        .generateCodeForExclusiveProduct(this.product.event.id, quota)
        .toPromise();

      if (response?.success) {
        this.shareCode.set(response.code);
        this.securityPhrase.set(response.security_phrase.phrase);
        this.openShareCodeModal();
      }
    } catch (err) {
      console.error(err);
      this.toast.show(this.translate.instant('generate-code-modal.error'), 3000, 'error');
    } finally {
      this.isLoading.set(false);
    }
  }

  async openShareCodeModal() {
    this.closeModal();
    const initialBreakpoint = 0.65;

    const modal = await this.modalCtrl.create({
      component: ShareCodeModalComponent,
      componentProps: {
        securityPhrase: this.securityPhrase(),
        shareCode: this.shareCode(),
        product: this.product,
      },
      breakpoints: [0, 0.5, 0.65, 0.75, 0.95],
      initialBreakpoint,
      cssClass: 'custom-modal-options',
      handle: true,
    });

    await modal.present();
  }

}
